import {formatMessage} from "devextreme/localization";

export const formatMessageExt = (key, value) => {
    for (let i = 0; i < value.length; i++) {
        value[i] = formatMessage(value[i]);
    }

    return formatMessage(key, value);
}

export const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

export const hasNumber = (str) => {
    return /\d+/.test(str);
}

export const hasLowerCase = (str) => {
    return  /[a-z]+/.test(str);
}

export const hasUpperCase = (str) => {
    return  /[A-Z]+/.test(str);
}

export const hasChars = (str, chars) => {
    const char_count = chars.length;
    const str_count = str.length;
    let hasChar  = false;
    for (let i=0; i < char_count; i++) {
        let char = chars[i];
        for(let k=0; k < str_count; k++) {
            if (char === str[k]) {
                hasChar = true;
                break;
            }
        }
    }

    return hasChar;
}

export const hasUnicodeChars = (str) => {
    return /[^\x00-\x7F]+/.test(str);
}
